import React from "react";
import { GoalClockIcon } from "@/apps/goals/assets/icons";
import { GoalHeroStripes } from "@/apps/goals/components/GoalHeroStripes/GoalHeroStripes";
import { GoToParkButton } from "@/apps/goals/components/NextGoalButton/GoToParkButton";
import { GoalProgressBlock } from "@/apps/goals/components/GoalProgressBlock/GoalProgressBlock";
import { NextGoalCard } from "@/apps/goals/components/NextGoalCard/NextGoalCard";
import { ShareButton } from "@/apps/goals/components/ShareButton/ShareButton";
import { useCurrentGoalData } from "@/apps/goals/hooks/useCurrentGoalData";
import { useGoalParkTitle } from "@/apps/goals/hooks/useGoalParkTitle";
import { useShareGoal } from "@/apps/goals/hooks/useShareGoal";
import { useTimeLeft } from "@/apps/goals/hooks/useTimeLeft";
import {
  formatGoalRewardAmount,
  formatTimeLeft,
} from "@/apps/goals/utils/formatTime";
import Typography from "@/ui/Typography/Typography";
import { useServiceT } from "@/utils/hooks/useServiceT";
import cls from "./styles.module.scss";

export const ActiveGoalPage = () => {
  const serviceT = useServiceT();
  const goalParkTitle = useGoalParkTitle();
  const {
    rewardAmount,
    ridesRequired,
    completedRides,
    expiresAt,
  } = useCurrentGoalData();
  const timeLeft = useTimeLeft(expiresAt ?? Date.now());
  const shareGoal = useShareGoal();

  return (
    <section className={cls.root}>
      <div className={cls.content}>
        <div className={cls.hero}>
          <GoalHeroStripes />
          <img className={cls.targetIcon} src="/goals/target.png" alt="" />
        </div>
        <div className={cls.timeBadge}>
          <GoalClockIcon />
          <Typography component="span" size="sm" weight="medium" family="Onest">
            {formatTimeLeft(timeLeft)}
          </Typography>
        </div>
        <div className={cls.copy}>
          <Typography component="p" size="md" weight="bold">
            {goalParkTitle}
          </Typography>
          <Typography
            className={cls.goal}
            component="h1"
            size="2xl"
            weight="semibold"
            family="custom"
          >
            {serviceT("goals.common.goalReward", {
              count: ridesRequired,
              price: formatGoalRewardAmount(rewardAmount),
            })}
          </Typography>
        </div>
        <GoalProgressBlock
          completedRides={completedRides}
          ridesRequired={ridesRequired}
          variant="active"
        />
        <ShareButton
          variant={timeLeft > 0 ? "primary" : "graphite"}
          onClick={() =>
            shareGoal({
              variant: "active",
              rewardAmount,
              ridesRequired,
            })}
        />
        <NextGoalCard startsAt={expiresAt} />
        <GoToParkButton />
      </div>
    </section>
  );
};
